import { use_slice_ui } from '@/hooks/store/use_slices';
import { WatcherViewEntityUserTaskGeneration } from '../_base/watchers/viewers/WatcherViewEntityUserTaskGeneration';
import { WATCHER__user_task_load_generations } from '../_base/watchers/WATCHER__user_task_load_generations';
import { WATCHER__disable_generation_ui } from '../page_generation/_watchers/generation/WATCHER__disable_generation_ui';
import { WATCHER_SLUG__page_user_task } from './_watchers/WATCHER_SLUG__page_user_task';
import { PageUserTasksViewsMobile } from './PageUserTasksViewsMobile';
import { U_PAGE_LAYOUT_DESKTOP__user_task } from './U_PAGE_LAYOUT_DESKTOP__user_task';
import { WATCHER__select_created_user_task } from './user_tasks_list/buttons/_watchers/watcher_select_created_user_task';

export function U_PAGE__user_task() {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  /*
   * EFFECTS
   */
  return (
    <>
      <WATCHER_SLUG__page_user_task />
      <WatcherViewEntityUserTaskGeneration />
      <WATCHER__disable_generation_ui />
      <WATCHER__user_task_load_generations />
      <WATCHER__select_created_user_task />

      {global_is_mobile ? <PageUserTasksViewsMobile /> : <U_PAGE_LAYOUT_DESKTOP__user_task />}
    </>
  );
}
